import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedComponentsModule } from '../shared-components/shared-components.module';

import { AnonymousLayoutComponent } from './layouts/anonymous/anonymous-layout.component';
import { AuthenticatedLayoutComponent } from './layouts/authenticated/authenticated-layout.component';
import { NavbarComponent } from './navbar/navbar.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { DemoComponent } from './demo/demo.component';
import { StartComponent } from './start/start.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgbModule,
        SharedComponentsModule.forRoot({})
    ],
    declarations: [
        AnonymousLayoutComponent,
        AuthenticatedLayoutComponent,
        NavbarComponent,
        WelcomeComponent,
        UnauthorizedComponent,
        DemoComponent,
        StartComponent
    ],
})
export class MainModule { }
